var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-3 pa-3",attrs:{"flat":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getHtmlString)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }